import { apiRequest } from '../utils/useAPIRequest';
import constant from '../utils/constant';
import { virtualCardStore } from '../stores';


// const getVirtualCardCharge = async (query) => {
// 	const { status, errorMessage, data } = await apiRequest({
// 		url: `/charges/calculate-charge?${query}`,
// 		method: 'get',		 
// 	});
// 	if (status === constant.Success) {	
// 		virtualCardStore.setCardCharge(data);
// 		return { status };		
// 	}		
// 	return { status, errorMessage };
// };

const createVirtualCard = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/stripe/dollarCard',
		method: 'get',
	});

	if (status === constant.Success) {
		await viewVirtualCard();		
		return { status };		
	}	
	return { status, errorMessage };
};

const deactivateVirtualCard = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/stripe/deactivate',
		method: 'get',
	});	
	if (status === constant.Success) {	
		virtualCardStore.setCard()				
		return { status }
	}
	return { status, errorMessage };
};

const freezeVirtualCard = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/stripe/freeze',
		method: 'get',
	});
	
	if (status === constant.Success) {
		await viewVirtualCard();
		return { status }
	}
	return { status, errorMessage };
};

const unfreezeVirtualCard = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/stripe/un-freeze',
		method: 'get',
	});

	if (status === constant.Success) {
		await viewVirtualCard();
		return { status }
	}
	return { status, errorMessage };
};

const viewVirtualCard = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/stripe/view-card',
		method: 'get',
	});	
	if (status === constant.Success) {
		virtualCardStore.setCardDetails(data);
		return { status: constant.Success };
	} 

	return { status, errorMessage };
};



export default {
	// getVirtualCardCharge,
	createVirtualCard,
	deactivateVirtualCard,
	freezeVirtualCard,
	unfreezeVirtualCard,
	viewVirtualCard,

};
